import React from 'react';
import { createPortal } from 'react-dom';
import MediaPreviewDialog from 'application/components/MediaPreviewDialog';
import { VideoPreview } from './VideoPreview';
import { ImagePreview } from './ImagePreview';
import { DATA_TEST_IDS } from './consts';
import { MediafilePreviewProps } from './types';
import styles from './index.module.scss';

export const MediafilePreview: React.FC<MediafilePreviewProps> = ({ url, isVideo, onClose }) =>
  createPortal(
    <MediaPreviewDialog
      onClose={onClose}
      layoutClassName={styles.layout}
      overlayClassName={styles.overlay}
      backButtonClassName={styles.chevronLeft}
      modalTestId={DATA_TEST_IDS.MODAL}
      closeTestId={DATA_TEST_IDS.CLOSE}>
      {isVideo ? <VideoPreview url={url} /> : <ImagePreview url={url} />}
    </MediaPreviewDialog>,
    document.body
  );
